import { create } from 'zustand';
import { persist } from 'zustand/middleware';
import Cookies from 'js-cookie';
import { User } from '@/models/user.model';

export type EnsureAuthenticatedStateParams = {
  user?: User;
  authenticated: boolean;
  setAuthenticated: ({ isAuthenticated, user }: { isAuthenticated: boolean, user?: User }) => void;
  removeAuthentication: () => void
};

export const ensureAuthenticatedStorage = create<EnsureAuthenticatedStateParams>()(
  persist(
    (set) => ({
      authenticated: Boolean(Cookies.get('session')),
      user: undefined,
      setAuthenticated: ({ isAuthenticated, user }: { isAuthenticated: boolean, user?: User }) => {
        set({ authenticated: isAuthenticated, user: user });
      },
      removeAuthentication: () => set({ authenticated: false, user: undefined })
    }),
    {
      name: 'auth-storage',
      getStorage: () => localStorage,
    }
  )
);

export const useEnsureAuthenticated = () => {
  const { authenticated, setAuthenticated, user, removeAuthentication } = ensureAuthenticatedStorage();
  return {
    authenticated,
    setAuthenticated,
    user,
    removeAuthentication,
  };
};

export default ensureAuthenticatedStorage;

